module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-6-819e9e54820821d4d81c55091c21dca2.svg";